export type LoginType = 'cloud' | 'onPrem';

export const LoginType = {
  Cloud: 'cloud',
  OnPrem: 'onPrem',
} as const;

export interface OnPremLoginDetails {
  host: string;
  clientId?: string;
  database?: string;
  customerId?: string;
}
